<div class="d-flex">
    <span
        [kno2Popover]="popover"
        popoverTitle="All Activities"
        [popoverContext]="event()"
        popoverPlacement="bottom"
        class="dashboard-status"
        [class]="event().status | lowercase">
        {{ event().status }}
    </span>
</div>

<ng-template
    #popover
    let-event>
    <div>
        <div style="margin-left: 10px">
            <small>
                <strong>Source:</strong>
                {{ event.origin }}
            </small>
        </div>
        <div>
            <table class="table">
                <tbody>
                    @for (subEvent of event.events; track $index) {
                        <tr>
                            <td>
                                <div class="row">
                                    <div class="col-sm-5">
                                        <div
                                            class="dashboard-status"
                                            [class]="subEvent.eventType | lowercase">
                                            {{ subEvent.eventType }}
                                        </div>
                                    </div>
                                    <div class="col-sm-7 text-end">
                                        {{ subEvent.createdDate + "Z" | date: "MM/dd/yy hh:mm a" }}
                                    </div>
                                    @if (subEvent.eventType === "Failed") {
                                        <div class="col-sm-12">
                                            {{ subEvent.reason }}
                                        </div>
                                    }
                                </div>
                            </td>
                        </tr>
                    }
                </tbody>
            </table>
        </div>
    </div>
</ng-template>
